import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-errors": "",
  class: "mt-6 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700"
}
const _hoisted_2 = { class: "space-y-1 text-base leading-7 text-gray-900" }
const _hoisted_3 = { class: "list-disc space-y-1 pl-5 text-sm text-gray-600" }

import { computed } from 'vue'

import HelpHint from '@/components/neue/wizard/HelpHint.vue'
import HighlightedText from '@/components/neue/wizard/HighlightedText'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { sectionCopy } from '@/config/membershipTierWizardSteps'
import { dropHint } from '@/helpers/membershipTierWizardSummary'


export default {
  __name: 'StepReview',
  props: {
  description: { type: Object, required: true },
  errors: { type: Array, default: () => [] }
},
  setup(__props) {



const wizard = injectWizard()
const repeats = computed(() => wizard.data.includes.repeat)
const dropText = computed(() => dropHint(wizard.data))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.errors.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (error) => {
            return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('summary', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.description.sentences, (sentence) => {
            return (_openBlock(), _createElementBlock("p", { key: sentence }, [
              _createVNode(_unref(HighlightedText), { text: sentence }, null, 8, ["text"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('notIncluded', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.description.notes, (note, index) => {
            return (_openBlock(), _createElementBlock("li", { key: note }, [
              _createVNode(_unref(HighlightedText), { text: note }, null, 8, ["text"]),
              (repeats.value && index === 0)
                ? (_openBlock(), _createBlock(HelpHint, {
                    key: 0,
                    class: "ml-1",
                    label: "What is a drop?",
                    text: dropText.value
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

}